import {internalApi} from "../../common/axios";
import {useMutationBase, useQueryBase} from "../../shared/hooks/useHookBase";
import {buildUrl} from "../../shared/utils/net";

const fetchStoreManagerData = async (url) => {
    const {data} = await internalApi.get(url);
    return data;
}

export const useStoreManagerData = (url) => {
    return useQueryBase(['storeManager', url], () => fetchStoreManagerData(url));
}

const saveStoreManagerData = async (row) => {
    return await internalApi.post("store_manager", {id: row.index, data: row.toJson()});
}

export const useSaveStoreManagerData = () => {
   return useMutationBase('storeManager', saveStoreManagerData);
};

const copyStoreManagerData = async (row) => {
    return await internalApi.post("store_manager/copy", {data: row.toJson()});
}

export const useCopyStoreManagerData = () => {
    return useMutationBase('storeManager', copyStoreManagerData);
};

const deleteStoreManagerData = async (seq) => {
    return await internalApi.delete(buildUrl('store_manager', {seq}));
}

export const useDeleteStoreManagerData = () => {
    return useMutationBase('storeManager', deleteStoreManagerData);
};

const fetchStoreOnIndexList = async () => {
    const {data} = await internalApi.get('store_manager/onList');
    return data.rows;
}

export const useStoreOnIndexList = () => {
    return useQueryBase('storeOnIndexList', fetchStoreOnIndexList)
}